<header>
</header>
<section>
  <div class="container main-div">
    <div class="login d-flex justify-content-center">
        <div class="col-lg-6 exp-div">
            <div class="row">
                <div class=" d-flex align-items-center left-div-main">
                    <div class="left-div w-100">
                        <div class="logodiv">
                            <a href="/" class="logo"><img [src]="brand.logo" alt="Scan My Invoice"></a>
                        </div>
                        
                        <label class="frm-label text-center w-100 mb-3">Reset your account password</label>
                        <form method="post" enctype="multipart/form-data" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                            <div class="errrorMsg" *ngIf="errorMsg">{{ errorMsg }}</div>
                            <div class="row">
                                <div class="col-md-12">
                                    <mat-form-field appearance="outline" class="full-width">
                                      <mat-label>Enter New Password</mat-label>
                                      <input  matInput [type]="showPassword ? 'text' : 'password'"  matInput placeholder="Your New Password" name="password" formControlName="password">
                                      <mat-icon matSuffix  [hidden]="!showPassword" (click)="togglePasswordVisibility()">visibility</mat-icon>
                                      <mat-icon matSuffix [hidden]="showPassword" (click)="togglePasswordVisibility()">visibility_off</mat-icon>  
                                      <mat-error *ngIf="!loginForm.controls['password'].valid && loginForm.controls['password'].touched">Please enter new password</mat-error>
                              
                                    </mat-form-field>     
                                </div>

                                <div class="col-md-12" style="text-align: center;">
                                    <button mat-fab class="signinbut radius-20-ico" aria-label="icon-button with a east icon">
                                        Reset Password 
                                    </button>
                                </div>
    
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>
        
    </div>
    
  </div>
  

  <div [hidden] = "!showprogress" id="pageloader" class="page-loader flex-column ">
    <span class="spinner-border text-primary" role="status"></span>
    <span class="text-gray-800 fs-6 fw-semibold mt-5">Requesting Please Wait...</span>
  </div>

</section>
<footer>

</footer>
